import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Editor, Button } from "components/common/common";
import s from "./ViewArticle.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchArticle, deleteArticle } from "store/articlesSlice";
import { serverPath } from "config/config";
import { Eye } from "lucide-react";

const ViewArticle = () => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userSide = false;

  const { currentArticle, loading: isLoading, error } = useSelector((state) => state.articles);

  useEffect(() => {
    dispatch(fetchArticle({ hash, userSide }));
  }, [hash, dispatch]);

  const copyBookmarkLink = (bookmarkId) => {
    const bookmarkLink = `${serverPath}/art/${hash}?bookmark=${bookmarkId}`;
    navigator.clipboard
      .writeText(bookmarkLink)
      .then(() => {
        alert("Ссылка на закладку скопирована!");
      })
      .catch((err) => {
        console.error("Не удалось скопировать ссылку:", err);
        // Fallback для старых браузеров
        const textArea = document.createElement("textarea");
        textArea.value = bookmarkLink;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          alert("Ссылка на закладку скопирована!");
        } catch (e) {
          console.error("Не удалось скопировать ссылку (fallback):", e);
          alert("Не удалось скопировать ссылку");
        }
        document.body.removeChild(textArea);
      });
  };

  const handleDelete = async () => {
    if (!window.confirm("Вы уверены, что хотите удалить эту статью?")) {
      return;
    }

    try {
      await dispatch(deleteArticle(hash)).unwrap();
      navigate("/admin/articles");
    } catch (err) {
      console.error("Ошибка при удалении статьи:", err);
    }
  };

  const handleEdit = () => {
    navigate(`/admin/articles/edit/${hash}`, {
      state: {
        articleData: currentArticle?.content,
        title: currentArticle?.meta?.title,
        userDescription: currentArticle?.meta?.userDescription || currentArticle?.meta?.shortDescription,
        shortDescription: currentArticle?.meta?.shortDescription,
        isEditing: true,
      },
    });
  };

  const copyArticleLink = () => {
    const articleLink = `${serverPath}/art/${hash}`;
    navigator.clipboard
      .writeText(articleLink)
      .then(() => {
        alert("Ссылка скопирована в буфер обмена!");
      })
      .catch((err) => {
        console.error("Не удалось скопировать ссылку:", err);
        // Fallback для старых браузеров
        const textArea = document.createElement("textarea");
        textArea.value = articleLink;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          alert("Ссылка скопирована в буфер обмена!");
        } catch (e) {
          console.error("Не удалось скопировать ссылку (fallback):", e);
          alert("Не удалось скопировать ссылку");
        }
        document.body.removeChild(textArea);
      });
  };

  if (isLoading) return <div>Загрузка...</div>;
  if (error) return <div className={s.error}>{error}</div>;
  if (!currentArticle) return <div>Данные статьи отсутствуют</div>;

  return (
    <div>
      <div className={s.container}>
        <div className={s.views}>
          <div className={s.viewsicon}>
            <Eye
              size="14"
              color="#959393"
            />
          </div>
          <div>{currentArticle.meta.views}</div>
        </div>
        <div className={s.header}>
          <h1>{currentArticle.meta.title}</h1>
          <div className={s.actions}>
            <Button
              onClick={handleEdit}
              label="Редактировать"
              variant="primary"
              className={s.editButton}
            />
            <Button
              onClick={copyArticleLink}
              label="Копировать ссылку"
              variant="secondary"
              className={s.copyButton}
            />
            <Button
              onClick={handleDelete}
              label="Удалить статью"
              variant="danger"
            />
          </div>
        </div>
        <Editor
          data={currentArticle.content}
          readOnly={true}
          holder={`viewer-${hash}`}
          key={`${hash}`}
          viewMode="viewArticle"
          config={{
            serverPath: serverPath,
            articleHash: hash,
          }}
        />
      </div>
    </div>
  );
};

export default ViewArticle;
